import { FC, ReactNode } from "react";
import { Heading } from "@digipost/dds-heading-react";
import styles from "./LoginCard.module.less";
import Translated from "../infrastructure/translation/Translated";
import ChevronRight from "./chevron-right.svg?react";
import { findURIAndReplaceOrigin } from "../infrastructure/entrypoint/link";
import { useEntrypointContext } from "../infrastructure/entrypoint/EntrypointContext";
import { TranslationKey } from "../infrastructure/translation/translator";

type Props = {
  loginMethod?: "nbid" | "buypass";
  title: TranslationKey;
  description: TranslationKey;
  icon: ReactNode;
};

export const LoginCard: FC<Props> = ({
  loginMethod,
  title,
  description,
  icon,
}) => {
  const entrypoint = useEntrypointContext();

  const doAuth = () => {
    const url = findURIAndReplaceOrigin("login", entrypoint._links);
    window.location.href = url + "&idpPreselect=" + loginMethod;
  };

  return (
    <>
      <button className={styles.loginCard} onClick={doAuth}>
        <div className={styles.textCard}>
          <div className={styles.loginCardIcon}>{icon}</div>
          <span aria-hidden="true" role="presentation" />
          <div>
            <Heading level={3} size={"xsmall"}>
              <Translated textKey={title} />
            </Heading>
            <Translated textKey={description} />
          </div>
        </div>
        <div className={styles.chevron}>
          <ChevronRight />
        </div>
      </button>
    </>
  );
};
